/** @format */

import { FilePdfOutlined, FileImageOutlined } from "@ant-design/icons";
import { Checkbox, Form, Modal, Radio } from "antd";
import React, { useState } from "react";
import { TExportOptions } from "../utils/exportChart";

interface Props {
  open: boolean;
  exporting: boolean;
  onCancel: () => void;
  onExport: (options: TExportOptions) => void;
}

const DEFAULTS: TExportOptions = {
  area: "all",
  format: "pdf",
  page: "a4",
  orientation: "auto",
  withLegend: true,
};

export const ExportModal = ({ open, exporting, onCancel, onExport }: Props): JSX.Element => {
  const [options, setOptions] = useState<TExportOptions>(DEFAULTS);
  const set = (patch: Partial<TExportOptions>): void => setOptions(current => ({ ...current, ...patch }));
  const isPdf = options.format === "pdf";

  return (
    <Modal
      title="Esporta organigramma"
      visible={open}
      onCancel={onCancel}
      onOk={(): void => onExport(options)}
      okText={isPdf ? "Scarica PDF" : "Scarica PNG"}
      cancelText="Annulla"
      confirmLoading={exporting}
      width={520}
    >
      <Form layout="vertical" className="org-export-form">
        <Form.Item
          label="Cosa esportare"
          extra={
            options.area === "all"
              ? "Tutto l'organigramma, indipendentemente da zoom e posizione. I rami compressi restano compressi."
              : "Esattamente la porzione che stai vedendo adesso, con lo zoom attuale."
          }
        >
          <Radio.Group
            value={options.area}
            onChange={(e): void => set({ area: e.target.value })}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button value="all">Organigramma intero</Radio.Button>
            <Radio.Button value="view">Vista corrente</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="Formato">
          <Radio.Group value={options.format} onChange={(e): void => set({ format: e.target.value })}>
            <Radio.Button value="pdf">
              <FilePdfOutlined /> PDF
            </Radio.Button>
            <Radio.Button value="png">
              <FileImageOutlined /> Immagine PNG
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        {isPdf && (
          <>
            <Form.Item label="Pagina">
              <Radio.Group value={options.page} onChange={(e): void => set({ page: e.target.value })}>
                <Radio.Button value="a4">A4</Radio.Button>
                <Radio.Button value="a3">A3</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item label="Orientamento">
              <Radio.Group
                value={options.orientation}
                onChange={(e): void => set({ orientation: e.target.value })}
              >
                <Radio.Button value="auto">Automatico</Radio.Button>
                <Radio.Button value="landscape">Orizzontale</Radio.Button>
                <Radio.Button value="portrait">Verticale</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Checkbox
                checked={options.withLegend}
                onChange={(e): void => set({ withLegend: e.target.checked })}
              >
                Includi intestazione, data e legenda delle strutture
              </Checkbox>
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};
